<template>
  <div
    class="text-sm uppercase font-bold tracking-wide"
    :class="statusClass"
  >
    <font-awesome-icon
      class="pr-1"
      icon="circle"
    />
    {{ value }}
  </div>
</template>

<script>
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
  name: 'StatusCircle',

  props: {
    value: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      statuses: {
        active: [
          'Active',
          'Coming Soon',
          'Active Under Contract',
        ],
        pending: [
          'Pending',
          'Under Contract',
        ],
        sold: [
          'Sold',
          'Rented',
          'Closed',
          'Leased',
        ],
      },
    };
  },

  computed: {
    /** @type {object} */
    statusClass() {
      const value = this.value.toLowerCase();
      const normalizeStatuses = (statuses) => statuses.map((status) => status.toLowerCase());

      return {
        'text-status-active': normalizeStatuses(this.statuses.active).includes(value),
        'text-status-pending': normalizeStatuses(this.statuses.pending).includes(value),
        'text-status-sold': normalizeStatuses(this.statuses.sold).includes(value),
      };
    },
  },

  created() {
    library.add(faCircle);
  },
};
</script>
